<script setup>
import "@/assets/main.css";
import SiteUnderConstruction from "@/components/maintenance/SiteUnderConstruction.vue";
</script>

<template>
    <SiteUnderConstruction />
</template>